var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"loading",attrs:{"show":_vm.count > 0,"z-index":"10000","no-wrap":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }